import { useLayoutEffect, useState } from 'react';
import style from '../HeaderButtons.module.scss';

export const useIconWrapperStyle = headerColorScheme => {
  const [headBarIconWrapperStyle, setHeadBarIconWrapperStyle] = useState(style.headerBar__iconwrapper);

  useLayoutEffect(() => {
    if (headerColorScheme === '' || headerColorScheme === 'blackOnTransparent') {
      setHeadBarIconWrapperStyle(` ${style.headerBar__iconwrapper} ${style.headerBarWhite__iconwrapper}`);
    } else if (headerColorScheme === 'blackOnTransparentTwo') {
      setHeadBarIconWrapperStyle(` ${style.headerBar__iconwrapper} ${style.headerBarTrans__iconwrapper}`);
    } else if (headerColorScheme === 'blackOnTransparentThree') {
      setHeadBarIconWrapperStyle(` ${style.headerBar__iconwrapper} ${style.headerBarTrans__iconwrapper}`);
    } else {
      setHeadBarIconWrapperStyle(`${style.headerBar__iconwrapper}`);
    }
  }, [headerColorScheme]);

  return headBarIconWrapperStyle;
};
